import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'dda-page',
  styleUrl: 'dda-page.css',
  shadow: false,
})
export class DdaPage {
  @Prop() customclass?: string = '';

  render() {
    return (
      <Host>
        <dda-header
          logo="https://www.digitaldubai.ae/ResourcePackages/Theme/assets/dist/images/logo.svg"
          menuitems="Dashboard,Modules,Profile,Settings"
          username="Cristopher Colani"
          userrole="UI/UX"
          userimage="https://play-lh.googleusercontent.com/LeX880ebGwSM8Ai_zukSE83vLsyUEUePcPVsMJr2p8H3TUYwNg-2J_dVMdaVhfv1cHg"
          showsearch={false}
          showdropdown={false}
        ></dda-header>
        <section>
          <p>
            Digital Dubai was established by His Highness Sheikh Mohammed Bin Rashid Al Maktoum, Vice-President & Prime Minister of the UAE, and Ruler of Dubai, in June 2021 to
            develop and oversee the implementation of policies and strategies that govern all matters related to Dubai’s information technology, data, digital transformation, and
            cyber-security. Digital Dubai brings together the expertise of four entities – Dubai Electronic Security Center, Dubai Statistics Center, Dubai Data Establishment,
            Smart Dubai Government Establishment - to ensure the city collaboratively achieves the vision of the city’s leadership to make Dubai a globally leading digital economy.
          </p>
        </section>
      </Host>
    );
  }
}
